import { connect } from 'react-redux';
import { negate } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { AppClockServiceProps } from '@mews/framework';
import { getTasksStatisticsChartData, isLoaded } from '../selectors/tasks';
import { navigateToTaskReport, stopTasksStatisticsPoller, startTasksStatisticsPoller } from '../actions/tasks';
import ConnectedPieChart, { ConnectedPieChartProps } from '../../charts/PieChart/ConnectedPieChart';
import { trackDashboardPieClick } from '../actions/util';

type StateProps = Pick<ConnectedPieChartProps, 'data' | 'showEmpty' | 'showLoader'>;
type DispatchProps = Pick<ConnectedPieChartProps, 'onClick' | 'onMount' | 'onUnmount'>;

export default connect<StateProps, DispatchProps, AppClockServiceProps, ApplicationState>(
    createStructuredSelector({
        data: getTasksStatisticsChartData,
        showLoader: negate(isLoaded),
        showEmpty: () => true,
    }),
    (dispatch: CommanderThunkDispatch) => ({
        onMount: () => dispatch(startTasksStatisticsPoller()),
        onClick: () => {
            dispatch(trackDashboardPieClick('TaskStatisticsChart'));
            dispatch(navigateToTaskReport());
        },
        onUnmount: () => dispatch(stopTasksStatisticsPoller()),
    })
)(ConnectedPieChart);
